<ng-template>
  <div (click)="vedLukket.emit()" class="panel" [style.width]="bredde()">
    <ng-content></ng-content>
  </div>
</ng-template>
